import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../lib/api";

/**
 * "Обсудить проект" callback modal — captures phone only (name optional).
 */
export default function CallbackModal({ onClose }) {
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener("keydown", onKey);
    };
  }, [onClose]);

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    const trimmed = phone.trim();
    if (trimmed.length < 4) {
      toast.error("Укажите телефон");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/callbacks`, { phone: trimmed, name: name.trim() });
      setSuccess(true);
      toast.success("Спасибо! Перезвоним.");
    } catch (err) {
      const msg = err?.response?.data?.detail;
      toast.error(typeof msg === "string" ? msg : "Не удалось отправить");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="callback-modal"
      className="fixed inset-0 z-[200] bg-black/85 backdrop-blur-md flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-md bg-[#0a0a0a] border border-white/10 p-8 sm:p-10"
      >
        <button
          aria-label="Закрыть"
          data-testid="callback-close"
          onClick={onClose}
          className="absolute top-3 right-3 w-10 h-10 flex items-center justify-center border border-white/15 hover:bg-white hover:text-black"
        >
          <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
            <path d="M2 2 L14 14 M14 2 L2 14" stroke="currentColor" strokeWidth="1.5" />
          </svg>
        </button>

        {success ? (
          <div data-testid="callback-success">
            <p className="font-mono-jb text-[11px] uppercase tracking-[0.22em] text-[#a78bfa]">
              Заявка принята
            </p>
            <h3 className="mt-3 font-display uppercase text-2xl sm:text-3xl tracking-tight">
              Перезвоним в ближайшее время.
            </h3>
            <p className="mt-5 text-white/65 text-sm leading-relaxed">
              Спасибо. Наш продюсер свяжется с вами в течение рабочего дня. Если срочно — пишите на
              {" "}<span className="text-white">bigbagfilms@gmail.com</span>.
            </p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-6" noValidate>
            <div>
              <p className="font-mono-jb text-[11px] uppercase tracking-[0.22em] text-[#a78bfa]">
                / Обсудить проект
              </p>
              <h3 className="mt-3 font-display uppercase text-2xl sm:text-3xl tracking-tight">
                Оставьте номер — перезвоним.
              </h3>
              <p className="mt-3 text-white/55 text-sm">
                Без формальностей: расскажем про процесс, сроки и команду.
              </p>
            </div>

            <label className="block">
              <span className="font-mono-jb text-[11px] uppercase tracking-[0.22em] text-white/40">
                Телефон <span className="text-[#a78bfa]">*</span>
              </span>
              <input
                data-testid="callback-phone"
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="+7 ___ ___ __ __"
                autoFocus
                required
                className="mt-2 w-full bg-transparent border-0 border-b border-white/15 focus:border-[#a78bfa] outline-none px-0 py-3 text-lg sm:text-xl text-white placeholder:text-white/20 transition-colors"
              />
            </label>

            <label className="block">
              <span className="font-mono-jb text-[11px] uppercase tracking-[0.22em] text-white/40">
                Имя (по желанию)
              </span>
              <input
                data-testid="callback-name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Как к вам обращаться"
                className="mt-2 w-full bg-transparent border-0 border-b border-white/15 focus:border-[#a78bfa] outline-none px-0 py-3 text-base sm:text-lg text-white placeholder:text-white/20 transition-colors"
              />
            </label>

            <div className="pt-2">
              <button
                type="submit"
                data-testid="callback-submit"
                disabled={loading}
                className="bbf-btn-primary w-full px-6 py-4 uppercase text-[11px] tracking-[0.22em] font-bold disabled:opacity-60"
              >
                {loading ? "Отправляем…" : "Отправить"}
              </button>
              <p className="mt-3 font-mono-jb text-[10px] uppercase tracking-[0.22em] text-white/35">
                Отправляя форму, вы соглашаетесь, что мы свяжемся для подтверждения.
              </p>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
